module.exports = __webpack_public_path__ + "img/man-emition-delivery.ea807a1.png";